import React from 'react';
import '../../assets/css/logo-spinner.css';

interface RocketSpinnerProps {
  size?: number;
  text?: string;
  minHeight?: string;
  fullScreen?: boolean;
}

const RocketSpinner: React.FC<RocketSpinnerProps> = ({ 
  size = 60, 
  text = "Lädt...",
  minHeight = "400px",
  fullScreen = false
}) => {
  const containerStyle = fullScreen 
    ? { height: '100vh', backgroundColor: 'var(--vz-body-bg)' }
    : { minHeight };

  return (
    <div className="d-flex justify-content-center align-items-center" style={containerStyle}>
      <div className="text-center">
        <img 
          src="/assets/images/space_logo_final_centered.svg" 
          alt="Loading..." 
          className="logo-spinner"
          style={{
            width: `${size}px`,
            height: `${size}px`,
            marginBottom: '1rem'
          }}
        />
        {text && <p className="text-muted">{text}</p>}
      </div>
    </div>
  );
};

export default RocketSpinner;
